var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg004C4KUhd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.667,
    height: 451.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 250.168682,
    width: 250.168682,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 224.459066,
    cy: 225.79493,
    id: "svg_5",
    rx: 213.74094,
    ry: 213.823302
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 42.397986,
    y: 69.392955,
    width: 366.003714,
    height: 256.256036,
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_2",
    d: "m400.135283,55.338082l0,-0.600854l-1.93064,0l-347.876078,0l-1.93064,0l0,0.600854c-11.381497,0.815013 -19.872833,10.24876 -21.222864,21.698557l0,2.015379l0,238.813691c0,4.630941 1.156709,8.534143 3.087349,12.04998c4.44189,8.14812 10.99872,12.26481 20.0668,12.26481l126.955694,0l0,33.362512l-24.116891,0c-5.980731,0 -10.611432,4.845772 -10.611432,11.063773c0,6.218002 4.630701,11.063102 10.611432,11.063102l142.198471,0c5.980731,0 10.805398,-4.845772 10.805398,-11.063102c0,-6.218673 -4.824023,-11.063773 -10.805398,-11.063773l-24.116891,0l0,-33.362512l126.95505,0c9.071946,0 15.686773,-4.11669 20.0668,-12.26481c1.987992,-3.687701 3.28067,-7.633198 3.28067,-12.04998l0,-238.81302l0,-2.015379c-1.350675,-11.450468 -10.418755,-20.884214 -21.41683,-21.699228zm0,23.714607l0,238.813691c0,1.415196 -0.576743,2.015379 -1.93064,2.015379l-347.876078,0c-1.35003,0 -1.93064,-0.600183 -1.93064,-2.015379l0,-238.813691l0,-2.015379l351.736714,0l0,2.015379l0.000644,0z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "null",
    strokeLinejoin: "null",
    id: "svg_6",
    y2: 400.367308,
    x2: 431.88195,
    y1: 395.528597,
    x1: 35.914127,
    strokeOpacity: "null",
    strokeWidth: "null",
    stroke: "null",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_14",
    d: "m223.826963,136.983012l-150.83626,0c-3.591071,0 -6.501972,2.718187 -6.501972,6.071513l0,67.807085l0,5.985071l0,36.181875c0,3.352799 2.910901,6.071513 6.501972,6.071513l150.836825,0c3.590506,0 6.501972,-2.718187 6.501972,-6.071513l0,-36.181875l0,-5.985071l0,-67.807085c-0.000564,-3.353326 -2.91203,-6.071513 -6.502536,-6.071513l-0.000001,0zm-125.410892,82.578166l-12.876376,0l0,8.10396l11.536922,0l0,2.536869l-11.536922,0l0,9.881824l-2.820023,0l0,-23.058994l15.696964,0l0,2.536342l-0.000564,0l-0.000001,-0.000001zm24.343305,11.03509c0,5.995613 -3.880637,9.620389 -10.336888,9.620389c-6.491247,0 -10.406316,-3.624776 -10.406316,-9.620389l0,-13.571432l2.822281,0l0,13.571432c0,4.480238 2.891145,7.08352 7.584034,7.08352c4.692325,0 7.514606,-2.603282 7.514606,-7.08352l0,-13.571432l2.822281,0l0,13.571432l0.000002,0zm20.568786,9.487563l-13.653068,0l0,-23.058994l2.822281,0l0,20.55744l10.830787,0l0,2.501554zm18.23984,0l-13.653068,0l0,-23.058994l2.821152,0l0,20.55744l10.831351,0l0,2.501554l0.000564,0l0.000001,0zm26.105538,0l-6.28014,0l0,-8.959422l-10.228512,0l0,8.959422l-6.280705,0l0,-23.058994l6.280705,0l0,9.487563l10.228512,0l0,-9.487563l6.28014,0l0,23.058994zm15.313134,0l-10.372448,0l0,-13.283115l6.279576,0l0,8.607328l4.480654,0c3.845076,0 6.597365,-2.769314 6.597365,-6.819976c0,-4.087031 -2.893403,-6.885335 -6.879593,-6.885335l-10.478002,0l0,-4.677896l10.619116,0c7.761274,0 13.122479,4.677896 13.122479,11.52897c0,6.818922 -5.432892,11.530024 -13.369147,11.530024zm14.338882,-35.293734l-137.833446,0l0,-55.664585l137.833446,0l0,55.664585z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#193351",
    id: "svg_15",
    points: "126.7455515917618,197.0951632285578 137.5436270824748,197.0951632285578 137.5436270824748,187.6834956270759 143.75998713943136,187.6834956270759 143.75998713943136,179.43458660664328 137.5436270824748,179.43458660664328 137.5436270824748,170.26802507936372 126.7455515917618,170.26802507936372 126.7455515917618,179.43458660664328 117.06062911029949,179.43458660664328 130.671939023684,154.3188828186394 119.48159532822865,154.3188828186394 105.01908958826971,180.41284942200582 105.01908958826971,187.6834956270759 126.7455515917618,187.6834956270759 ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#193351",
    id: "svg_16",
    points: "160.90816156486744,186.58451555337524 166.99412809119622,180.2900447055581 179.10057934896304,197.0951632285578 193.03927573446617,197.0951632285578 174.9123397452613,172.04008455373696 191.92728534585785,154.3188828186394 178.44636146232278,154.3188828186394 160.90816156486744,172.83493234413618 160.90816156486744,154.3188828186394 149.259467807512,154.3188828186394 149.259467807512,197.0951632285578 160.90816156486744,197.0951632285578 ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_17",
    height: 36.499887,
    width: 152.611813,
    y: 212.52221,
    x: 72.102925,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 160.47502,
    y: 213.156985,
    width: 57.101963,
    height: 37.134663,
    id: "svg_18",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    d: "m220.779245,206.230432l-63.846058,0c-1.52003,0 -2.752158,1.169974 -2.752158,2.61282l0,45.365399c0,1.442846 1.232128,2.612821 2.752158,2.612821l63.846296,0c1.519792,0 2.752158,-1.169747 2.752158,-2.612821l0,-45.365399c-0.000239,-1.442846 -1.232606,-2.61282 -2.752397,-2.61282l0.000001,0zm-41.735134,35.502734l2.386606,-7.932821l-8.907302,0l-2.387561,7.932821l-5.467045,0l6.142481,-20.41443l5.468478,0l-2.52757,8.399177l8.906824,0l2.52757,-8.399177l5.468956,0l-6.143914,20.41443l-5.467523,0zm33.513064,-10.207215c-1.816774,6.036547 -7.802759,10.207215 -14.714096,10.207215l-9.030347,0l4.058352,-13.48736l5.467045,0l-2.81165,9.345045l3.900901,0c3.348272,0 6.481514,-2.449051 7.560491,-6.035186c1.088296,-3.616756 -0.684516,-6.095068 -4.155594,-6.095068l-9.124006,0l1.246463,-4.141861l9.246334,0c6.757948,0 10.180286,4.141861 8.356106,10.207215l0.000001,0z",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#e3e8ee",
    strokeWidth: 0,
    strokeOpacity: "null",
    x: 114.0037,
    y: 248.620848,
    id: "svg_20",
    fontSize: 24,
    fontFamily: "Oswald, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    transform: "matrix(1.0251172053275257,0,0,1.1378219967573824,-36.03596881931141,-41.219399945682056) ",
    fontStyle: "italic",
    stroke: "null"
  }, "ULTRA"), /*#__PURE__*/React.createElement("path", {
    d: "m371.557716,167.410749c-17.680868,-31.084566 -56.841732,-41.735567 -87.463532,-23.785622c-30.624246,17.94415 -41.117929,57.691993 -23.433798,88.775317c17.678421,31.084566 56.838062,41.737223 87.460269,23.788934c30.624654,-17.950359 41.12323,-57.696133 23.43706,-88.778629l0.000001,0zm-29.838402,77.518313c-24.495727,14.360287 -55.826294,5.838989 -69.969847,-19.029905c-14.146815,-24.863927 -5.748851,-56.665017 18.747691,-71.018267c24.497358,-14.359459 55.826294,-5.838989 69.970662,19.029077c14.144776,24.867653 5.749259,56.662119 -18.748506,71.019095zm-2.560618,-47.66438l-33.527422,-19.847844c-3.055288,-1.810558 -5.519664,-0.363022 -5.502536,3.224152l0.171687,39.395998c0.015497,3.586346 2.51005,5.046301 5.57431,3.249816l33.270912,-19.497654c3.060997,-1.793173 3.067522,-4.713909 0.01305,-6.524468l-0.000001,0z",
    id: "svg_1",
    stroke: "null",
    fill: "#ff0033"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg004C4KUhd);
export default __webpack_public_path__ + "static/media/004c-4K-UHD.8a844637907ee91cbf50695ae77c5622.svg";
export { ForwardRef as ReactComponent };